var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.57 21.2h-1.88a.56.56 0 0 0-.39.15l-.4.39a20 20 0 0 0-2.95-4.72 3.7 3.7 0 0 0-2.88-1.36h-7.52a3.7 3.7 0 0 0-2.87 1.36 19.53 19.53 0 0 0-2.97 4.71l-.4-.38a.56.56 0 0 0-.38-.15h-1.88c-.3 0-.55.25-.55.55v1.29c0 .3.23.53.52.55l1.93.12c-.29.86-.52 2.13-.52 3.92 0 1.55.31 2.58.85 3.24v3c0 .25.21.46.47.46h2.14c.25 0 .46-.21.46-.47V32h13.92v1.86c0 .26.2.47.46.47h2.14c.26 0 .47-.21.47-.47v-3c.54-.65.85-1.68.85-3.23 0-1.8-.23-3.06-.52-3.92l1.93-.12c.3-.02.52-.26.52-.55v-1.29c0-.3-.25-.55-.55-.55zm-17.3-2.88c.3-.39.78-.6 1.28-.6h7.52c.5 0 .97.21 1.29.6.92 1.12 1.64 2.2 2.2 3.26H18.05a19.46 19.46 0 0 1 2.21-3.26zm-1.59 11.4c-1.06 0-1.93-.34-1.93-1.18 0-.85.32-1.53 1.38-1.53 1.06 0 2.48.68 2.48 1.53 0 .84-.87 1.19-1.93 1.19zm8.65-.17h-4.04c-.6 0-1.1-.5-1.1-1.1 0-.17.14-.31.3-.31h5.63c.18 0 .31.14.31.3 0 .62-.5 1.11-1.1 1.11zm4.61.18c-1.06 0-1.93-.35-1.93-1.2 0-.84 1.42-1.52 2.48-1.52s1.38.68 1.38 1.53c0 .84-.87 1.19-1.93 1.19z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});